document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
        let subMenus = document.querySelectorAll(
            '.mobileNav__list .menu-item-has-children'
        );
        subMenus.forEach((subMenu) => {
            let link = subMenu.querySelector('a');
            let span = subMenu.querySelector('span');
            let ul = subMenu.querySelector('ul');
            link.addEventListener('click', (e) => {
                if (subMenu.querySelector('span')) {
                    e.preventDefault();
                    ul.classList.toggle('sub-menu--open');
                    span.classList.toggle('open');
                }
            });
        });
    }
    const hamburgers = document.querySelectorAll('.header .hamburger');
    const mobileNav = document.querySelector('.mobileNav');
    hamburgers.forEach(hamburger => {
        hamburger.addEventListener('click', () => {
            hamburgers.forEach(h=>{
                h.classList.toggle('hamburger--opened');
                h.setAttribute(
                    'aria-expanded',
                    h.classList.contains('hamburger--opened')
                );
            })
            mobileNav.classList.toggle('open');
            if (document.querySelector('.mobileNav__list .menu-item-has-children') && !hamburger.classList.contains('hamburger--opened')) {
                let subMenus = document.querySelectorAll(
                    '.mobileNav__list .menu-item-has-children'
                );

                subMenus.forEach((subMenu) => {
                    let span = subMenu.querySelector('span');
                    let ul = subMenu.querySelector('ul');
                    ul.classList.remove('sub-menu--open');
                    span.classList.remove('open');

                });
            }
        });

    });
    const mobileNavItems = document.querySelectorAll('.mobileNav a')
    if (mobileNavItems)
        mobileNavItems.forEach(mobileNavItem => {
            mobileNavItem.addEventListener('click', () => {
                hamburgers.forEach(h=>{
                    h.classList.toggle('hamburger--opened');
                    h.setAttribute(
                        'aria-expanded',
                        h.classList.contains('hamburger--opened')
                    );
                })
                mobileNav.classList.toggle('open');
            })
        });

    const header = document.querySelector('.floatingHeader');

    var lastPosition = document.documentElement.scrollTop;
    var direction = 'down';
    window.addEventListener('scroll', () => {

        if (lastPosition < document.documentElement.scrollTop)
            direction = 'down'
        else
            direction = 'up';


        direction == 'up' || mobileNav.classList.contains('open')
            ? header.classList.add('header--scrolled')
            : header.classList.remove('header--scrolled');

        lastPosition = document.documentElement.scrollTop;
        // console.log(direction)
        document.body.scrollTop > 40 || document.documentElement.scrollTop > 40
            ? header.style.display = "block"
            : header.style.display = "none";
    });

    const btn = document.querySelector('.scrollTop');

    btn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });

    window.onscroll = function () {
        scrollFunction();
    };

    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            btn.style.display = 'flex';
        } else {
            btn.style.display = 'none';
        }
    }



});